module.exports = __webpack_public_path__ + "static/media/02_tn.536ba337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/02_tn.jpg
// module id = 216
// module chunks = 0